import React from 'react';
import {
    Menu,
    Person,
    Flight,
    House,
    CarRental,
    ListAlt,
    BeachAccess,
    TravelExplore,
    Loyalty,
    AltRoute,
    DirectionsRunOutlined,
    CardTravelOutlined
} from '@mui/icons-material';

const SidebarData = [
    {
        title: '',
        icon: <Menu/>,
        link: '/menu'
    },
    {
        title: 'SOURAV',
        icon: <Person/>,
        link: '/user'
    },
    {
        title: 'Flights',
        icon: <Flight/>,
        link: '/flights'
    },
    {
        title: 'Stay',
        icon: <House/>,
        link: '/stay'
    },
    {
        title: 'Car Rental',
        icon: <CarRental/>,
        link: '/cars'
    },
    {
        title: 'Thinks To Do',
        icon: <ListAlt/>,
        link: '/thinks-to-do'
    },
    {
        title: 'Flight + Hotel',
        icon: <BeachAccess/>,
        link: '/holidays'
    },
    {
        title: 'Explore',
        icon: <TravelExplore/>,
        link: '/explore'
    },
    {
        title: 'Deals',
        icon: <Loyalty/>,
        link: '/deals'
    },
    {
        title: 'Routes',
        icon: <AltRoute/>,
        link: '/routes'
    },
    {
        title: 'Direct',
        icon: <DirectionsRunOutlined/>,
        link: '/direct'
    },
    {
        title: 'Trips',
        icon: <CardTravelOutlined/>,
        link: '/trips'
    },
]

export default SidebarData;
